module.exports = __webpack_public_path__ + "img/f0ef035.svg";